$(document).ready(function () {
    $("body").on("click", "#wof_widget_add_to_cart", function () {
        const $successMessage = $("#wof_widget_success_message");

        if ($successMessage.length === 1 && $successMessage.css("display") === "block") {
            console.log("✅ Success message visible, proceeding...");
                setTimeout(() => {
                  window.addEventListener('theme:cart:updated', ({ detail: cart }) => {
                    console.log(cart);
                  });
                  location.reload();
                        // window.Drawer.open('right', 'cart-drawer');
                  }, 100); // small delay to ensure cart HTML is updated before opening

           // $.getJSON("/cart.js", function (cart) {
           //    console.log("cart", cart)
           //     if(cart.item_count) {
           //        setTimeout(()=> {
           //         window.addEventListener('theme:cart:updated', ({ detail: cart }) => {
           //            console.log("cart update", cart)
           //        });
           //        },300)
           //    } else {
                
           //    }
           //  }).fail(function () {
           //      console.error("❌ Failed to fetch cart data.");
           //  });

        } else {
            console.warn("❗ Success message not visible or missing. Aborting...");
            // Optionally show a warning or disable the add to cart flow
        }
    });
});



